import React from 'react';

interface AccountCreatedProps {
  clientName?: string;
  email: string;
  onContinue: () => void;
}

const AccountCreated: React.FC<AccountCreatedProps> = ({
  clientName = "there",
  email,
  onContinue
}) => {
  return (
    <div className="app">
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        background: '#28527A',
        borderRadius: '16px',
        padding: '2rem',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
        marginTop: '2rem'
      }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{
            width: '80px',
            height: '80px',
            background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 1rem auto',
            fontSize: '2rem',
            color: 'white'
          }}>
            ✓
          </div>
          <h1 style={{ color: '#f9fafb', fontSize: '2rem', margin: '0 0 0.5rem 0' }}>
            Account Created Successfully!
          </h1>
          <p style={{ color: '#6CA6C1', margin: 0 }}>Welcome to My ClinicCore</p>
        </div>

        {/* Success Content */}
        <div style={{
          background: '#113F67',
          borderRadius: '12px',
          padding: '2rem',
          textAlign: 'left',
          border: '1px solid #6CA6C1',
          marginBottom: '2rem'
        }}>
          <p style={{
            fontSize: '1.1rem',
            marginBottom: '1.5rem',
            color: '#f9fafb'
          }}>
            Hi {clientName},
          </p>

          <p style={{
            fontSize: '1rem',
            lineHeight: '1.6',
            marginBottom: '1.5rem',
            color: '#d1d5db'
          }}>
            Your account has been created with the email address: <strong style={{ color: '#f9fafb' }}>{email}</strong>
          </p>

          <div style={{
            background: '#065f46',
            borderRadius: '8px',
            padding: '1.5rem',
            marginBottom: '1.5rem',
            border: '1px solid #10b981'
          }}>
            <h3 style={{ color: '#f9fafb', margin: '0 0 1rem 0', fontSize: '1.1rem' }}>
              Next Steps:
            </h3>
            <ul style={{ color: '#d1d5db', margin: 0, paddingLeft: '1.2rem' }}>
              <li style={{ marginBottom: '0.5rem' }}>Sign in to your secure portal</li>
              <li style={{ marginBottom: '0.5rem' }}>Complete medical questionnaires</li>
              <li style={{ marginBottom: '0.5rem' }}>Review and sign consent forms</li>
              <li style={{ marginBottom: '0.5rem' }}>Schedule your first appointment</li>
            </ul>
          </div>

          <p style={{
            fontSize: '0.875rem',
            lineHeight: '1.6',
            color: '#d1d5db',
            marginBottom: 0
          }}>
            You can log back in anytime using your email address to complete your forms or schedule appointments.
          </p>
        </div>

        {/* Continue Button */}
        <div style={{ textAlign: 'right' }}>
          <button
            onClick={onContinue}
            style={{
              background: 'linear-gradient(135deg, #D4A017 0%, #B8860B 100%)',
              color: 'white',
              padding: '0.75rem 2rem',
              fontSize: '1rem',
              fontWeight: '600',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              boxShadow: '0 4px 14px 0 rgba(212, 160, 23, 0.3)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 20px 0 rgba(212, 160, 23, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 14px 0 rgba(212, 160, 23, 0.3)';
            }}
          >
            Continue to Sign In
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountCreated;